module.exports = __webpack_public_path__ + "img/green-carpet-grass-03.7d984c42.png";